import { ExcelJSService, consoleErrorMsg } from "@pes-ui/utils";
import lodash from 'lodash';
import styler, { ROW_TYPE } from "./MpcStylesExcel";
import {TOTAL_LABEL, columnsDefaultValues, styles, } from "./constants";
import { formatPrice } from "../../common/utils";
import { TExcelData,TExcelItem} from "./types";
import { MPC_ROW_TYPE } from "./constants";
import { DIR } from "../../constants/constants";

export class GenerateExcel {
  private workbook;
  private worksheet;
  private excelData: TExcelData;
  private dir;
  private rowIndex = 1;
  private columnsConfig;
  private getRow() {
    return this.worksheet.getRow(this.rowIndex++);
  }
  constructor(excelData: TExcelData) {
    this.excelData = excelData;
    this.dir = document.dir;
    this.columnsConfig = {
      emptyColumns: styles.emptyColumnIndex,
      totalColumns: columnsDefaultValues.length,
      filler: styles.LITERALS.DASH,
    }
  }

  renderDisclaimer(disclaimer: string) {
    const disclaimRow = this.worksheet.addRow();
    const nRow = this.worksheet.rowCount;
    this.worksheet.mergeCells(`A${nRow}:K${nRow}`);
    disclaimRow.getCell(1).value = disclaimer;
    styler.styleRow(disclaimRow, ROW_TYPE.DISCLAIMER);
   }

  renderItem(item: TExcelItem) {
    const { 
      partNumber,
      quantity,
      itemType ,
      configurationId,
      codification,
      shortDescription,
      shippingDays,
      price,
      currency, 
      subtotal,
      elNumber,
      hasStatus
    } = item;
    let excelPriceContent = null, excelCurrency = currency;
    if (!price || !currency) {
      excelCurrency = styles.LITERALS.DASH;
      excelPriceContent = {
        hyperlink: hasStatus? this.excelData.contactSalesURL: this.excelData.callUsUrl,
        text: hasStatus? this.excelData.contactSalesLabel: this.excelData.callUsText,
      }
    }
    const priceContent = excelPriceContent? excelPriceContent : formatPrice(price, this.excelData.locale);
    const subtotalContent = subtotal ? formatPrice(subtotal, this.excelData.locale): styles.LITERALS.EMPTY;
    const shouldCapitalize = itemType !== MPC_ROW_TYPE.BOM_PRODUCT
      && itemType !== MPC_ROW_TYPE.CTO_CONFIGURATION
      && itemType !== MPC_ROW_TYPE.NOT_AVAIABLE;
    const rowType = shouldCapitalize ? lodash.capitalize(itemType): itemType; 
   
    const values = ExcelJSService.makeSingleItemRow([ partNumber,
      quantity,
      rowType,
      configurationId,
      codification,
      elNumber,
      shortDescription,
      shippingDays,
      priceContent,
      excelCurrency,
      !price || !currency ? excelPriceContent: subtotalContent ],
      this.columnsConfig
    );
    return this.dir === DIR.rtl ? values.reverse(): values;
  }

  addSubtotalRow() {
    const totalLalbel = this.excelData.totalLabel || TOTAL_LABEL;
    const total = this.excelData.total;
    const nRow = this.worksheet.addRow();
    const rows = this.worksheet.rowCount;
    const columns = this.worksheet.columnCount;
    if(this.dir=== DIR.ltr) {
      nRow.getCell(columns - 1).value = formatPrice(Number(total), this.excelData.locale);
      nRow.getCell(columns - 2).value = this.excelData.currency;
      this.worksheet.mergeCells(`A${rows}:I${rows}`);
      nRow.getCell(1).value = totalLalbel;
    } else {
      nRow.getCell(2).value = formatPrice(Number(total), this.excelData.locale);
      nRow.getCell(3).value = this.excelData.currency;
      this.worksheet.mergeCells(`D${rows}:L${rows}`);
      nRow.getCell(columns).value = totalLalbel;
    } 
    styler.styleRow(nRow, ROW_TYPE.SUBTOTAL);
  }

  private makeHeader() {
    this.worksheet.columns = this.excelData.headerValues.map(({ key, hidden, width,header }) => {
      return { key, header, hidden, width };
    });
    const header = this.getRow();
    styler.styleRow(header, ROW_TYPE.HEADER);
  }

  getSingleItem(subsSectionStore) {
    const { partNumber, quantity, substitutionText , shortDescription,currency,price
    } = subsSectionStore;
    const excelRow = this.getRow();
    const rows = this.rowIndex-1;
    if(this.dir=== DIR.rtl) {
      excelRow.getCell(this.worksheet.columnCount).value = substitutionText;
      this.worksheet.mergeCells(`F${rows}:L${rows}`);
    } else {
      this.worksheet.mergeCells(`A${rows}:L${rows}`);
      excelRow.getCell(1).value = substitutionText;
    }
    const values = this.renderItem({
      partNumber,
      quantity,
      itemType: MPC_ROW_TYPE.NOT_AVAIABLE,
      shortDescription,
      currency,
      price,
    });
    styler.styleRow(excelRow, ROW_TYPE.SUBSTITUTION_TITLE);
    const eRow = this.getRow()
    styler.styleRow(ExcelJSService.populateRow(values, eRow),ROW_TYPE.SUBSTITUTION_ROW);
  }

  getRangeData(subsRange: TExcelItem) {
    const {substitutionText , quantity} = subsRange;
    const excelRow = this.getRow();
    const rows = this.rowIndex-1;
    if (this.dir === DIR.rtl) {
      excelRow.getCell(this.worksheet.columnCount).value = substitutionText;
      this.worksheet.mergeCells(`F${rows}:L${rows}`);
    } else {
      this.worksheet.mergeCells(`A${rows}:L${rows}`);
      excelRow.getCell(1).value = substitutionText;
    }
    const values = this.renderItem({
      partNumber: subsRange.partNumber,
      quantity: quantity,
      itemType: MPC_ROW_TYPE.NOT_AVAIABLE,
      shortDescription: subsRange.shortDescription
    });
    styler.styleRow(excelRow, ROW_TYPE.SUBSTITUTION_TITLE);
    const eRow = this.getRow();
    styler.styleRow(ExcelJSService.populateRow(values,eRow),ROW_TYPE.SUBSTITUTION_ROW);
  }

  getGroupData(subsGroup: TExcelItem) {
    const {substitutionText } = subsGroup;
    const excelRow = this.getRow();
    const rows = this.rowIndex-1;
    if(this.dir === DIR.ltr ) {
    this.worksheet.mergeCells(`A${rows}:L${rows}`);
    excelRow.getCell(1).value = substitutionText;
    } else {
      this.worksheet.mergeCells(`B${rows}:L${rows}`);
      excelRow.getCell(1).value = substitutionText;
    }
    const products = subsGroup.products?.map((product: TExcelItem) => {
      const { quantity } = product;
      const {partNumber, currency,shortDescription, price, productCode, configurationId } = product;
      return {
        partNumber,
        currency,
        shortDescription,
        configurationId,
        productCode,
        quantity,
        price,
      }
    });
    styler.styleRow(excelRow, ROW_TYPE.SUBSTITUTION_TITLE);
    products.forEach(product=> {
      const rows= this.renderItem(product);
      const eRow = this.getRow();
      styler.styleRow(ExcelJSService.populateRow(rows,eRow),ROW_TYPE.SUBSTITUTION_ROW);
    });
  }

  renderGroup(group) {
    const { 
      name, 
      quantity, 
      configurationId, 
      hiveId, 
      codification, 
      currency, 
      subtotal, 
      price,
      hasStatus 
    } = group;
    if (!this.excelData.currency) this.excelData.currency = currency;
    const groupHeader = this.renderItem({
      partNumber: name,
      quantity,
      itemType: !!hiveId ? MPC_ROW_TYPE.CTO_CONFIGURATION: MPC_ROW_TYPE.CONFIGURATION,
      configurationId,
      codification,
      productCode: styles.LITERALS.DASH,
      shortDescription: styles.LITERALS.DASH,
      shippingDays: styles.LITERALS.DASH,
      price,
      currency,
      subtotal,
      hasStatus
    });
    let rows = [];
    rows.push(groupHeader);
    const { products } = group;
    rows = rows.concat(products.map(product => {
      return this.renderItem(product)
    }));
    styler.styleRow(
        ExcelJSService.populateRow(rows[0],this.getRow()), 
        ROW_TYPE.GROUP_HEADER
        );
    for (let index = 1; index < rows.length; index++) {
      const eRow = this.getRow();
      styler.styleRow( ExcelJSService.populateRow(rows[index], eRow), 
                       ROW_TYPE.GROUP_ITEM
                    );
    }
    styler.addGroupBorder(rows[rows.length-1]);
  }

  renderSubstitutionSection(substitute) {
    const type = substitute.itemType;
    switch (type) {
      case MPC_ROW_TYPE.SUBSTITUTION_PRODUCT:
        this.getSingleItem(substitute);
      break;
      case MPC_ROW_TYPE.GROUP_PRODUCT:
        this.getGroupData(substitute);
      break;
      case MPC_ROW_TYPE.SUBSTITUTION_RANGE:
        this.getRangeData(substitute);
      break;
      default:
        console.log(`Substution type(${type}) unknown`)
    }
  }

  renderSubstitutionItems(card) {
    const substitutions = card.substitutions;
    substitutions?.map(subst => this.renderSubstitutionSection(subst));
  }

  addProductStatus(item) {
    const row = this.worksheet.getRow(this.rowIndex - 1);
    const isRtl = this.dir === DIR.rtl;
    const cell = isRtl? row.getCell(this.worksheet.columnCount): row.getCell(1);
    const { statusBarText, statusBarColor } = item;
    cell.value = {
      richText: [
        { 
          text: `${item.partNumber} \n`,
        },
        {
          text: `${statusBarText}`,
          font: {
            color: {
              argb: statusBarColor.replace('#', '').toUpperCase(),
              theme: 1,
            },     
          },
        },
      ],
    };
    cell.alignment =  {
      wrapText: true,
      horizontal: isRtl ? styles.ALIGNMENT.RIGHT_ALIGNMENT: styles.ALIGNMENT.LEFT_ALIGNMENT,
      indent: isRtl? styles.INDENT.RTL: styles.INDENT.LTR,
    }
  }

  shouldRenderPrice() {
    return !!this.excelData.total
        && !!this.excelData.currency 
        && !!this.excelData.isPriceEnabledOnSite;
  }

  renderItemToExcel(item: TExcelItem) {
    switch (item.itemType) {
      case MPC_ROW_TYPE.SINGLE_PRODUCT: 
        const dataRows = item.products.map(card => {
          const row = this.renderItem(card); 
          if (card.hasStatus) 
            this.addProductStatus(card);
          return row;
        });
        for (const dataRow of dataRows) 
          styler.styleRow(ExcelJSService.populateRow(dataRow, this.getRow()), ROW_TYPE.SINGLE_ITEM);
      break;
      case MPC_ROW_TYPE.GROUP_PRODUCT: 
        this.renderGroup(item);
        break;
      default:
        const row = this.renderItem(item);
        const eRow = this.getRow(); 
        styler.styleRow(ExcelJSService.populateRow(row, eRow), ROW_TYPE.SINGLE_ITEM);
        if (item.hasStatus) {
          this.addProductStatus(item);
          this.renderSubstitutionItems(item);
        }
    }
  }  

  hidePricesAndSubtotal() { // hide last 3 columns (for price, subtotal, curreny)
    let startIndex = this.dir === DIR.rtl? styles.EXCEL_ROW_START.RTL: this.worksheet.columnCount-1; 
    const columnIncrement = this.dir === DIR.rtl? styles.INCREMENT.RTL: styles.INCREMENT.LTR;
    for(let i = 0;i < 3; i++) {
      this.worksheet.getColumn(startIndex).hidden = true;
      startIndex+=columnIncrement;
    }
  }
  
  async exportToExcel() {
    try {
      const { excelJS, error } = await ExcelJSService.getExcelJS();
      if(error) throw error;
      this.workbook = new excelJS.Workbook();
      this.worksheet = this.workbook.addWorksheet('Sheet1');
      this.worksheet.properties.defaultRowHeight = styles.ROWS.HEADER_ROW_HEIGHT;
      this.makeHeader();
      this.excelData.products.forEach(item => this.renderItemToExcel(item));
      ExcelJSService.hideEmptyColumns(this.worksheet);
      if(this.shouldRenderPrice()) this.addSubtotalRow();
      if(this.excelData.weeePrice) this.renderDisclaimer(this.excelData.weeePrice);
      if(this.excelData.disclaimer) this.renderDisclaimer(this.excelData.disclaimer);
      const products = this.excelData.products.map(product => [product.substitutions, product.products, product]);
      const prices = products.flat(2).filter(product => !!product?.price);
      if(!prices.length)
        this.hidePricesAndSubtotal();
      await ExcelJSService.saveExcel(this.workbook, this.excelData.filename);
    }  
   catch(error) {
    consoleErrorMsg(error, 'exportToExcel while executing addProductDetails');
    }
  }
}

